export default __webpack_public_path__ + "static/media/navBackground.863fd789.png";